import React, { FC } from 'react';
import { Accordion, Box } from '@chakra-ui/react';
import { closestCenter, DndContext, DragEndEvent } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { MenuCategory } from 'types/menuCategory';
import { OriginalMenu } from 'types/menu';
import { MenuCategoryListItem } from './MenuCategoryListItem';
import { MenuCategoryListHeader } from './MenuCategoryListHeader';
import { MenuCategoryListEmpty } from './MenuCategoryListEmpty';

type Props = {
  /** メニューカテゴリー一覧ローディング */
  loading: boolean;
  /** メニューカテゴリー一覧 */
  listItems: MenuCategory[];
  /** アコーディオンの開閉状態 */
  accordionIndex: number[];
  /** メニューカテゴリーのアコーディオンの開閉時の処理 */
  handleChangeAccordion: (index: number[]) => void;
  /** 並び替え実行前の popover 表示状態チェック */
  checkOpenStateSortPopover: (id: MenuCategory['id']) => boolean;
  /** 並び替え実行 */
  handleSort: () => void;
  /** 並び替え実行キャンセル */
  handleCancelSort: () => void;
  /** カテゴリーごとのメニュー一覧を取得する */
  getNestedListItems: (categoryId: number) => OriginalMenu[];
  /** メニューカテゴリー登録モーダルを開く */
  handleClickAdd: () => void;
  /** メニューカテゴリー詳細モーダルを開く */
  handleClickMenuCategoryRow: (menuCategory: MenuCategory) => void;
  /** メニュー登録モーダルを開く */
  handleClickAddMenu: (categoryId: MenuCategory['id']) => void;
  /** メニュー詳細モーダルを開く */
  handleClickMenuRow: (menu: OriginalMenu) => void;
  /** メニューカテゴリーの並び替え */
  handleDragEnd: (event: DragEndEvent) => void;
  /** メニュー並び替え実行前の処理 */
  handleDragStartMenus: (menus: OriginalMenu[]) => void;
  /** メニューの並び替え */
  handleDragEndMenus: (event: DragEndEvent) => void;
  /** メニュー並び替え実行前の popover 表示状態チェック */
  checkOpenStateSortPopoverMenu: (id: OriginalMenu['id']) => boolean;
  /** メニュー並び替え実行 */
  handleCancelSortMenu: () => void;
  /** メニュー並び替え実行キャンセル */
  handleSortMenu: () => void;
};

export const MenuCategoryListView: FC<Props> = ({
  loading,
  listItems,
  accordionIndex,
  handleChangeAccordion,
  checkOpenStateSortPopover,
  handleCancelSort,
  handleSort,
  getNestedListItems,
  handleClickAdd,
  handleClickMenuCategoryRow,
  handleClickAddMenu,
  handleClickMenuRow,
  handleDragEnd,
  handleDragStartMenus,
  handleDragEndMenus,
  checkOpenStateSortPopoverMenu,
  handleCancelSortMenu,
  handleSortMenu,
}) => (
  <>
    <Box m="20px 0 0 0">
      <MenuCategoryListHeader />
    </Box>
    {loading || (
      <Accordion
        h="60vh"
        overflowY="scroll"
        overflowX="hidden"
        allowMultiple
        onChange={handleChangeAccordion}
        index={accordionIndex}
      >
        <DndContext
          modifiers={[restrictToVerticalAxis]}
          onDragEnd={handleDragEnd}
          collisionDetection={closestCenter}
        >
          <SortableContext
            items={listItems}
            strategy={verticalListSortingStrategy}
          >
            {listItems.length ? (
              listItems.map((item) => (
                <MenuCategoryListItem
                  key={item.id}
                  item={item}
                  checkOpenStateSortPopover={checkOpenStateSortPopover}
                  handleCancelSort={handleCancelSort}
                  handleSort={handleSort}
                  getNestedListItems={getNestedListItems}
                  handleClickAdd={handleClickAdd}
                  handleClickMenuCategoryRow={handleClickMenuCategoryRow}
                  handleClickAddMenu={handleClickAddMenu}
                  handleClickMenuRow={handleClickMenuRow}
                  handleDragStartMenus={handleDragStartMenus}
                  handleDragEndMenus={handleDragEndMenus}
                  checkOpenStateSortPopoverMenu={checkOpenStateSortPopoverMenu}
                  handleCancelSortMenu={handleCancelSortMenu}
                  handleSortMenu={handleSortMenu}
                />
              ))
            ) : (
              <MenuCategoryListEmpty handleClickAdd={handleClickAdd} />
            )}
          </SortableContext>
        </DndContext>
      </Accordion>
    )}
  </>
);
